import home from './home.js';

home.init();